import { useNavigate, useParams } from 'react-router-dom';
export var useRedirectToInteractions = function () {
    var id = useParams().id;
    var navigate = useNavigate();
    var redirect = function () {
        navigate("/client/".concat(id, "/appointments"));
    };
    return redirect;
};
